import { apiUrl, inboxApiUrl } from '@src/config/api-utils'
// MARK:- service call urls
export const LUMOTIVE_INBOX = inboxApiUrl + 'inbox'
export const LUMOTIVE_INBOX_SAVED_REPLIES = apiUrl + 'inbox/saved/reply'
